import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const getInitialLang = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    if (fromUrl && translations[fromUrl]) return fromUrl;
    return localStorage.getItem("eco-lang") || "pt";
  } catch {
    return "pt";
  }
};

const setMetaContent = (selector, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const t = translations[lang] || translations.pt;

  useEffect(() => {
    try {
      localStorage.setItem("eco-lang", lang);
    } catch {}
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set("lang", lang);
      window.history.replaceState(null, "", url);
    } catch {}
  }, [lang]);

  useEffect(() => {
    const { title, description, ogLocale } = t.seo;
    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[property="og:locale"]', ogLocale);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
  }, [t]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
